import { useStaticVirtualizerMeasure } from "@fluentui/react-components/unstable";
import { Virtualizer } from "@fluentui/react-virtualizer";
import { WorkspaceOptionsListStyles } from "../styles/WorkspaceOptionsListStyles.style";

type WorkspaceOptionsListProps = {
  options: any[];
};

export const WorkspaceOptionsList = ({ options }: WorkspaceOptionsListProps) => {
  const styles = WorkspaceOptionsListStyles();

  const itemHeight = 32;

  const numberOfItems = options.length;

  const { virtualizerLength, bufferItems, bufferSize, scrollRef, containerSizeRef } = useStaticVirtualizerMeasure({
    defaultItemSize: itemHeight,
    direction: "vertical",
  });

  return (
    <div ref={scrollRef} className={styles.container} role="list" aria-label="Workspace options">
      <Virtualizer
        numItems={numberOfItems}
        virtualizerLength={virtualizerLength}
        bufferItems={bufferItems}
        bufferSize={bufferSize}
        itemSize={itemHeight}
        containerSizeRef={containerSizeRef}
      >
        {(index) => {
          return <div className={styles.option}>{options[index]}</div>;
        }}
      </Virtualizer>
    </div>
  );
};
